import { defineStore } from 'pinia'
import { computed, watch } from 'vue'
import { useAuthStore } from '@/pinia/auth'

export const useAccessToken = defineStore('access_token', () => {
  const authStore = useAuthStore()
  const token = computed<string | undefined>(() => authStore.accessToken)
  const bearer = computed(() => (token.value ? `Bearer ${token.value}` : undefined))
  watch(
    token,
    (newToken) => {
      if (newToken) {
        localStorage.setItem('currentKeycloakToken', newToken)
      }
    },
    { immediate: true }
  )

  return { token, bearer }
})
